import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import { GeneralAdsPage } from '../../GeneralAdsPage';
import { setError } from '../../../actions';
import { CategoriesQuery } from '../../../graphql/graphql';

interface ItemsAllProps {
  sortingValue?: string;
  categories: CategoriesQuery['categories'];
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setErrorUI: (errorState: boolean) => dispatch(setError(errorState))
});

const connector = connect(null, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type CombinedProps = ItemsAllProps & PropsFromRedux;

const ItemsAllComponent: React.FC<CombinedProps> = ({
  sortingValue,
  setErrorUI,
  categories
}) => {
  return (
    <GeneralAdsPage
      transformedObj={{ sorting: sortingValue, filter: {} }}
      setErrorUI={setErrorUI}
      categories={categories}
    />
  );
};

export const ItemsAll = connector(ItemsAllComponent);
